import React, {useContext, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {fetchTelegramClients} from "../redux/actions";
import TelegramClient from "../elements/telegramClient";
import {Loader} from "../elements/loader";
import {Carcontext} from "../context/carcontext";

const TelegramClientsList = () => {

    const dispatch = useDispatch()
    const allTgClients = useSelector(state => state.telegramClients.allTgClients)
    const loading = useSelector(state => state.app.loading)
    const {theme} = useContext(Carcontext)

    useEffect(() => {
        dispatch(fetchTelegramClients())
    }, [])

    if (loading) {
        return <Loader theme={theme}/>
    }

    if (!allTgClients.length) {
        if (theme === 'dark') {
            return <h1 style={{color: 'white'}}>No clients</h1>
        } else {
            return <h1 style={{color: 'black'}}>No clients</h1>
        }
    }

    return (
        <div className="cards">
            {
                allTgClients.map((person, index) => <TelegramClient person={person} index={index} key={index}/>)
            }
        </div>
    )
}

export default TelegramClientsList